const hostname = window.location.hostname

const protocal = window.location.protocol

const domains = 'lk.chelun.com'
const premains = 'lkpre.chelun.com'

const testapi = [`${protocal}//lkapidev.ailky.com`, `${protocal}//pay-test.chelun.com`]
const prodapi = [`${protocal}//lkapi.chelun.com`, `${protocal}//pay.chelun.com`]
const preapi = [`${protocal}//lkapipre.chelun.com`]
export const baseUrl = (domains.indexOf(hostname) > -1) ? prodapi[0] : (premains.indexOf(hostname) > -1) ? preapi[0] : testapi[0]
export const payUrl = (domains.indexOf(hostname) > -1) ? prodapi[1] : testapi[1]
export const hostUrl = (domains.indexOf(hostname) > -1) ? `${protocal}//lk.chelun.com` : (premains.indexOf(hostname) > -1) ? `${protocal}//lkpre.chelun.com` : `${protocal}//lkdev.ailky.com`
export const walletUrl = domains.indexOf(hostname) > -1 ? `${protocal}//cjjl.chelun.com` : `${protocal}//dev.cjjl.chelun.com`
// export const OPENID = (domains.indexOf(hostname) > -1) ? `${protocal}//zhushouweixin.chaojijiaolian.cn` : `${protocal}//zhushou.weixin.chaojijiaolian.cn.chelun.com`
export const OPENID = (domains.indexOf(hostname) > -1) ? `${protocal}//zhushouweixin.chaojijiaolian.cn` : `${protocal}//zhushouweixin.chaojijiaolian.cn`
export const cjjlPay = (domains.indexOf(hostname) > -1) ? `${protocal}//xch5.chelun.com` : `${protocal}//xch5-test.chelun.com`
export const OPENIDNEW = (domains.indexOf(hostname) > -1) ? `${protocal}//xueche.chelun.com` : `${protocal}//xueche.chelun.com`




// WEBPACK FOOTER //
// ./src/http/env.js